import { render, staticRenderFns } from "./ReceiptOut.vue?vue&type=template&id=033c2ca3&scoped=true"
import script from "./ReceiptOut.vue?vue&type=script&lang=js"
export * from "./ReceiptOut.vue?vue&type=script&lang=js"
import style0 from "./ReceiptOut.vue?vue&type=style&index=0&id=033c2ca3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033c2ca3",
  null
  
)

export default component.exports